import infoKnockoutTokens from '@amzn/meridian-tokens/base/icon/info-knockout';
import Icon from '@amzn/meridian/icon';
import Table, { TableRow, TableCell } from '@amzn/meridian/table';
import Tooltip from '@amzn/meridian/tooltip';
import React from 'react';
import { OptionalExternalLink, TranslationFunction } from '../../components/blocks';
import { SalesOrderDemandShipment } from '../../redux/types';
import { formatDateIsoOrBlank } from '../../utils/dateUtils';
import { getVisibleShipmentColumns } from './shipmentUtils';

export const ShipmentDetails = ({
    shipments,
    asin,
    requestedShipDate,
    requestedDeliveryDate,
    t,
    timezone,
}: {
    shipments: SalesOrderDemandShipment[];
    asin?: string;
    requestedShipDate?: number;
    requestedDeliveryDate?: number;
    t: TranslationFunction;
    timezone?: string;
}) => {
    const visibleColumns = getVisibleShipmentColumns(shipments);

    const getUnitsForShipment = (shipment: SalesOrderDemandShipment) => {
        if (asin) {
            return shipment.items?.find((i) => i.asin === asin)?.shippedQuantity;
        }
        return shipment.units;
    };

    return (
        <Table headerRows={1} showDividers={true}>
            <TableRow>
                <TableCell>{t('shipmentId-column')}</TableCell>
                <TableCell>{t('units-column')}</TableCell>
                {visibleColumns.hasStatus && <TableCell>{t('status-column')}</TableCell>}
                <TableCell>{t('carrier-column')}</TableCell>
                {visibleColumns.hasTrackingNumber && <TableCell>{t('trackingNo-column')}</TableCell>}
                <TableCell>{t('requestedShipDate-column')}</TableCell>
                <TableCell>{t('shipDate-column')}</TableCell>
                <TableCell>{t('requestedDeliveryDate-column')}</TableCell>
                {visibleColumns.hasDeliveryDate && <TableCell>{t('deliveryDate-column')}</TableCell>}
            </TableRow>
            {shipments.map((shipment) => (
                <TableRow key={shipment.shipmentId} highlightOnHover={true}>
                    <TableCell>{shipment.shipmentId}</TableCell>
                    <TableCell>{getUnitsForShipment(shipment)}</TableCell>
                    {visibleColumns.hasStatus && <TableCell>{shipment.status || ''}</TableCell>}
                    <TableCell>
                        <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                            {shipment.carrierSCAC || ''}
                            {shipment.carrierSCAC === 'AZNG' && (
                                <Tooltip position={'top'} title={t('amazonFreightOrder-tooltip')}>
                                    <Icon tokens={infoKnockoutTokens} />
                                </Tooltip>
                            )}
                        </span>
                    </TableCell>
                    {visibleColumns.hasTrackingNumber && (
                        <TableCell>
                            <OptionalExternalLink href={shipment.trackingUrl} tooltip={t('trackingLink-tooltip')}>
                                {shipment.trackingNumber || ''}
                            </OptionalExternalLink>
                        </TableCell>
                    )}
                    <TableCell>{formatDateIsoOrBlank(requestedShipDate, timezone)}</TableCell>
                    <TableCell>{formatDateIsoOrBlank(shipment.shipDate, timezone)}</TableCell>
                    <TableCell>{formatDateIsoOrBlank(requestedDeliveryDate, timezone)}</TableCell>
                    {visibleColumns.hasDeliveryDate && (
                        <TableCell>{formatDateIsoOrBlank(shipment.deliveryDate, timezone)}</TableCell>
                    )}
                </TableRow>
            ))}
        </Table>
    );
};
